// Emoji guard shared by the customizer: strips pictographs, flags, skin tones,
// variation selectors (the U+FE0F in ❤️) and ZWJ joiners. ©, ® and ™ stay allowed.
window.PASSPORT_EMOJI_RE = /(?![\u00A9\u00AE\u2122])\p{Extended_Pictographic}|[\u{1F1E6}-\u{1F1FF}\u{1F3FB}-\u{1F3FF}\u{FE0E}\u{FE0F}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu;
window.stripPassportEmoji = function(value) {
    return typeof value === "string" ? value.replace(window.PASSPORT_EMOJI_RE, "") : value;
};

// Compact pack detection. The pack format value and the titles are translated per
// storefront locale (es/pt COMPACTO, en COMPACT, fr COMPACTE, de KOMPAKT, it COMPATTO),
// so matching only "compact" let the DE/IT storefronts submit one colour per passport
// on a Compact pack (order #27720, DE storefront, FAMILIA / KOMPAKT). Keep in sync with
// passport-cart-sync.js, cart-drawer.liquid, passport-customizer.liquid and
// product-variant-picker.liquid.
window.PASSPORT_COMPACT_RE = /compact|kompakt|compatt/i;
window.isPassportCompactText = function(value) {
    return window.PASSPORT_COMPACT_RE.test((value || "").toString());
};

// CRO personalization funnel (GTM dataLayer). The helper lives in
// passport-personalization-guard.js (once-per-page rule for personalize_start);
// fall back to a plain push if the guard is not on the page.
window.trackPassportPersonalization = function(eventName) {
    if (typeof window.pushPassportPersonalizationEvent === "function") {
        return window.pushPassportPersonalizationEvent(eventName);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName });
    return true;
};

// add_to_cart_personalizar: a /cart/add FormData body that carries passport
// properties and was NOT sent through "Añadir sin personalizar"
// (that path writes properties[_Customized] = "false").
window.isPersonalizedPassportCartAdd = function(body) {
    if (typeof FormData === "undefined" || !(body instanceof FormData)) return false;
    if (body.get("properties[_Customized]") === "false") return false;
    for (const key of body.keys()) {
        if (/^properties\[Pasaporte\d+\]$/.test(key)) return true;
    }
    return false;
};

// personalize_start from the PDP toggle. The inline onclick on the button runs
// first, so aria-expanded already holds the new state here.
document.addEventListener("click", function(e) {
    const toggle = e.target.closest && e.target.closest(".ppc__master-toggle");
    if (toggle && toggle.getAttribute("aria-expanded") === "true") {
        window.trackPassportPersonalization("personalize_start");
    }
});

(function() {
    const modal = document.getElementById("passport-customizer-modal");
    if (!modal) {
        
        return
    }
    const EXTERNAL_SCRIPTS = {
        cropper: "https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.13/cropper.min.js",
        html2canvas: "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"
    };
    const externalScriptPromises = {};
    // Cropper / html2canvas are only needed on user action, so load them on demand instead of on every PDP view.
    function loadExternalScript(name, globalName) {
        if (window[globalName]) return Promise.resolve();
        if (!externalScriptPromises[name]) {
            externalScriptPromises[name] = new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = EXTERNAL_SCRIPTS[name];
                script.onload = () => resolve();
                script.onerror = () => {
                    delete externalScriptPromises[name];
                    script.remove();
                    reject(new Error("Failed to load " + name))
                };
                document.head.appendChild(script)
            })
        }
        return externalScriptPromises[name]
    }
    const PASSPORT_COUNT = parseInt(modal.getAttribute("data-passport-count")) || 1;
    if (PASSPORT_COUNT === 0) {
        
        return
    }
    const PRODUCT_FORM_ID = modal.getAttribute("data-product-form-id") || "";
    const getModalText = (key, fallback = "") => modal.getAttribute(`data-text-${key}`) || fallback;
    const RANDOM_COLOR_LABEL = modal.getAttribute("data-random-color-label") || "Aleatorio";
    let activeCount = parseInt(modal.getAttribute("data-active-count")) || PASSPORT_COUNT;
    if (activeCount < 1) activeCount = 1;
    if (activeCount > PASSPORT_COUNT) activeCount = PASSPORT_COUNT;

    document.querySelectorAll(".passport-cropper-modal, #passport-preview-modal, #incomplete-passports-modal").forEach(function(el) {
        if (el.parentNode !== document.body) document.body.appendChild(el);
    });
    const TEXT_PASSPORT_LABEL = getModalText("passport-label", "Passport"),
        TEXT_UPLOAD_PHOTO = getModalText("upload-photo", "Upload Photo"),
        TEXT_CHANGE_PHOTO = getModalText("change-photo", "Change Photo"),
        TEXT_ALL_COMPLETED = getModalText("all-completed", "\u2713 All data completed"),
        TEXT_CLICK_TO_COMPLETE = getModalText("click-to-complete", "Click to complete the data"),
        TEXT_PHOTO_TOO_LARGE_ERROR = getModalText("photo-too-large-error", "The image is too large. Maximum size is 15MB."),
        TEXT_INVALID_IMAGE_FORMAT_ERROR = getModalText("invalid-image-format-error", "Invalid image format. Please upload a JPG or PNG image."),
        TEXT_CROP_PROCESSING = getModalText("crop-processing", "Processing..."),
        TEXT_CROP_SAVE = getModalText("crop-save", "Crop and Save"),
        TEXT_PROCESSING_IMAGES = getModalText("processing-images", "Processing images..."),
        TEXT_ADD_TO_CART = getModalText("add-to-cart", "Add to cart"),
        TEXT_PREVIEW_TITLE_PREFIX = getModalText("preview-title-prefix", "Preview"),
        TEXT_PREVIEW_GENERATING = getModalText("preview-generating", "Generating..."),
        TEXT_PREVIEW_GENERATE_ERROR = getModalText("preview-generate-error", "There was an error generating the image. Please try again."),
        TEXT_PREVIEW_DOWNLOAD_FILENAME = getModalText("preview-download-filename", "passport-preview"),
        TEXT_SAVE_FOR_LATER_SUCCESS = getModalText("save-for-later-success", "Passport data saved! You can continue later."),
        TEXT_SAVE_FOR_LATER_QUOTA_ERROR = getModalText("save-for-later-quota-error", "Unable to save all data. Storage limit exceeded. Some photos may not persist."),
        TEXT_SAVE_FOR_LATER_ERROR = getModalText("save-for-later-error", "Error saving passport data. Please try again."),
        TEXT_WAIT_FOR_IMAGES = getModalText("wait-for-images", "Please wait for images to finish processing."),
        TEXT_CHECKOUT_PROCESSING = getModalText("checkout-processing", "Processing..."),
        TEXT_CONTINUE_TO_CHECKOUT = getModalText("continue-to-checkout", "Continue to checkout"),
        TEXT_PRODUCT_FORM_NOT_FOUND_ERROR = getModalText("product-form-not-found-error", "Error: Product form not found. Please refresh and try again."),
        TEXT_PRODUCT_VARIANT_NOT_FOUND_ERROR = getModalText("product-variant-not-found-error", "Error: Product variant not found. Please refresh and try again."),
        TEXT_ADD_TO_CART_ERROR = getModalText("add-to-cart-error", "There was an error adding the product to the cart. Please try again."),
        TEXT_PREPARE_DATA_ERROR = getModalText("prepare-data-error", "There was an error preparing the passport data. Please try again."),
        TEXT_EXAMPLE_TITLE = getModalText("example-title", "Passport example"),
        TEXT_EMOJI_NOT_ALLOWED = getModalText("emoji-not-allowed", "Emojis are not allowed"),
        productTagsString = modal.getAttribute("data-product-tags") || "",
        productTitleString = modal.getAttribute("data-product-title") || "",
        initialCompactMode = modal.getAttribute("data-initial-compact-mode") === "true",
        productTags = productTagsString ? productTagsString.split(",").map(tag => tag.trim()) : [],
        editionTagsString = modal.getAttribute("data-edition-tags") || "",
        // Ordered edition list rendered by passport-customizer.liquid (edition_array:
        // world-edition first, then the rest). product.tags is alphabetical, so
        // filtering it here would not match the order of the accordion cards and
        // would submit crossed properties[PasaporteN] values.
        editionTags = editionTagsString
            ? editionTagsString.split(",").map(tag => tag.trim()).filter(Boolean)
            : productTags.filter(tag => tag.includes("edition")),
        productTitle = productTitleString.toLowerCase(),
        productIsCompactOnly = initialCompactMode || productTags.some(tag => window.isPassportCompactText(tag)) || window.isPassportCompactText(productTitle),
        isCaminoDeSantiago = productTags.includes("Camino de Santiago"),
        isSnow = productTags.includes("snow");

    function getEditionKey(editionTag = "") {
        const allTags = (editionTag + " " + productTags.join(" ")).toLowerCase();
        return allTags.includes("europe") ? "europe" : allTags.includes("usa") ? "usa" : allTags.includes("snow") ? "snow" : allTags.includes("camino") || allTags.includes("santiago") ? "camino" : "world"
    }
    const passportData = Array(PASSPORT_COUNT).fill(null).map(() => ({
        firstName: "",
        lastName: "",
        fecha: "",
        nationality: "",
        modalidad: "",
        phrase: "",
        photo: null,
        color: RANDOM_COLOR_LABEL
    }));
    let globalColor = RANDOM_COLOR_LABEL,
        previousCompletedCount = 0,
        updateTimeout = null,
        isSubmitting = !1,
        processingImages = 0;

    function isCompactFormatValue(value) {
        return window.isPassportCompactText(value)
    }

    function belongsToCustomizerProductForm(el) {
        if (!el) return !1;
        if (!PRODUCT_FORM_ID) return !0;
        if (el.getAttribute && el.getAttribute("form") === PRODUCT_FORM_ID) return !0;
        const productForm = document.getElementById(PRODUCT_FORM_ID);
        return !!(productForm && productForm.contains(el))
    }

    function getOwnPackFormatFieldsets() {
        return Array.prototype.filter.call(document.querySelectorAll('[data-pack-format-fieldset]'), fieldset => {
            const control = fieldset.querySelector('input[type="radio"], select');
            return belongsToCustomizerProductForm(control)
        })
    }

    function getSelectedPackFormatValue() {
        const fieldsets = getOwnPackFormatFieldsets();
        for (const fieldset of fieldsets) {
            const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
            if (checkedRadio) return checkedRadio.value || "";
            const formatSelect = fieldset.querySelector('select');
            if (formatSelect) {
                const selectedOption = formatSelect.options[formatSelect.selectedIndex];
                return formatSelect.value || (selectedOption ? selectedOption.textContent : "")
            }
        }
        return ""
    }

    function isCompactMode() {
        // Compact-only product (title/tags match PASSPORT_COMPACT_RE): a format selector
        // from another product's markup must never flip it to per-passport mode.
        if (productIsCompactOnly) return !0;
        const selectedFormatValue = getSelectedPackFormatValue();
        if (selectedFormatValue) return isCompactFormatValue(selectedFormatValue);
        return !1
    }

    function syncPassportColorInputs(index) {
        const savedColor = passportData[index]?.color || RANDOM_COLOR_LABEL;
        let hasMatch = !1;
        document.querySelectorAll(`input[type="radio"][data-field="color"][data-index="${index}"]`).forEach(radio => {
            const isMatch = radio.value === savedColor;
            radio.checked = isMatch;
            isMatch && (hasMatch = !0)
        });
        if (!hasMatch) {
            const fallbackRadio = document.querySelector(`input[type="radio"][data-field="color"][data-index="${index}"]`);
            fallbackRadio ? (fallbackRadio.checked = !0, passportData[index].color = fallbackRadio.value || RANDOM_COLOR_LABEL) : passportData[index].color = RANDOM_COLOR_LABEL
        }
    }

    function syncCompactColorInputs() {
        let hasMatch = !1;
        const radios = document.querySelectorAll('input[type="radio"][data-shared-color="true"]');
        radios.forEach(radio => {
            const isMatch = radio.value === globalColor;
            radio.checked = isMatch;
            isMatch && (hasMatch = !0)
        });
        if (!hasMatch) {
            const fallbackRadio = radios[0];
            fallbackRadio ? (fallbackRadio.checked = !0, globalColor = fallbackRadio.value || RANDOM_COLOR_LABEL) : globalColor || (globalColor = RANDOM_COLOR_LABEL)
        }
    }

    function initializeCustomizer() {
        document.querySelector('.passport-card[data-passport-index="0"]') && togglePassportCard(0), window.handleGlobalColorChange(globalColor, {
            skipProgress: !0
        }), updateProgress();
        if (window.toggleLinternaFields) window.toggleLinternaFields();
    }
    window.openPassportCustomizer = function() {
        const modal2 = document.getElementById("passport-customizer-modal");
        modal2 && (window.scrollTo(0, 0), modal2.style.display = "block", document.body.style.overflow = "hidden", requestAnimationFrame(() => {
            modal2.classList.add("passport-customizer-modal--active")
        }), modal2.addEventListener("transitionend", function onTransitionEnd(e) {
            e.target === modal2 && e.propertyName === "opacity" && (modal2.removeEventListener("transitionend", onTransitionEnd), initializeCustomizer())
        }))
    }, window.closePassportCustomizer = async function() {
        const modal2 = document.getElementById("passport-customizer-modal");
        if (modal2) {
            try {
                await persistPassportData();
            } catch (e) {}
            modal2.classList.remove("passport-customizer-modal--active"), modal2.addEventListener("transitionend", function cleanup(e) {
                e.target === modal2 && e.propertyName === "opacity" && (modal2.style.display = "none", document.body.style.overflow = "", modal2.removeEventListener("transitionend", cleanup), window.resetCustomizationFlag && window.resetCustomizationFlag())
            })
        }
    }, window.togglePassportCard = function(index, options = {}) {
        const {
            scrollIntoView = !1,
            scrollBehavior = "smooth",
            scrollBlock = "nearest"
        } = options;
        const card = document.querySelector(`.passport-card[data-passport-index="${index}"]`);
        if (!card) return;
        const content = card.querySelector(".passport-card__content"),
            chevron = card.querySelector(".passport-card__chevron"),
            isExpanded = content?.classList.contains("passport-card__content--expanded");
        document.querySelectorAll(".passport-card__content").forEach(c => {
            c.classList.remove("passport-card__content--expanded")
        }), document.querySelectorAll(".passport-card__chevron").forEach(ch => {
            ch.classList.remove("passport-card__chevron--expanded")
        }), document.querySelectorAll(".passport-card").forEach(c => {
            c.classList.remove("passport-card--expanded")
        }), isExpanded || (content?.classList.add("passport-card__content--expanded"), chevron?.classList.add("passport-card__chevron--expanded"), card.classList.add("passport-card--expanded"), content && (content.scrollTop = 0), scrollIntoView && requestAnimationFrame(() => {
            const header = card.querySelector(".passport-card__header");
            header && header.scrollIntoView({
                behavior: scrollBehavior,
                block: scrollBlock
            })
        }))
    };

    function updatePassportData(index, field, value) {
        passportData[index][field] = value, updateTimeout && clearTimeout(updateTimeout), updateTimeout = setTimeout(() => {
            updateProgress()
        }, 200)
    }
    document.addEventListener("input", function(e) {
        if (e.target.type !== "file" && e.target.dataset.field && e.target.dataset.index !== void 0) {
            const index = parseInt(e.target.dataset.index),
                field = e.target.dataset.field;
            if (updatePassportData(index, field, e.target.value), field === "phrase") {
                const counter = document.getElementById(`passport-phrase-counter-${index}`);
                counter && (counter.textContent = e.target.value.length);
                e.target.closest('.passport-form__textarea-wrap')?.classList.toggle('has-value', !!e.target.value)
            }
        }
    });

    function handleRadioSelection(target) {
        if (target.type === "radio" && target.dataset.field === "color") {
            
            const passportCard = target.closest(".passport-card");
            if (!passportCard) {
                
                return
            }
            const cardIndex = passportCard.getAttribute("data-passport-index"),
                index = parseInt(cardIndex);
            updatePassportData(index, "color", target.value), passportCard.querySelectorAll('input[type="radio"][data-field="color"]').forEach(radio => {
                radio.checked = radio === target
            })
        }
    }
    let lastProcessedRadio = {
        id: null,
        timestamp: 0
    };
    document.addEventListener("change", function(e) {
        if (e.target.tagName === "SELECT" && e.target.dataset.field && e.target.dataset.index !== void 0) {
            const index = parseInt(e.target.dataset.index),
                field = e.target.dataset.field;
            updatePassportData(index, field, e.target.value);
            return
        }
        if (e.target.type === "radio" && e.target.dataset.sharedColor === "true") {
            window.handleGlobalColorChange(e.target.value);
            return
        }
        if (e.target.type === "radio" && e.target.dataset.field === "color") {
            const now = Date.now();
            if (lastProcessedRadio.id === e.target.id && now - lastProcessedRadio.timestamp < 50) {
                
                return
            }
            lastProcessedRadio = {
                id: e.target.id,
                timestamp: now
            }, handleRadioSelection(e.target)
        }
    }), window.handleGlobalColorChange = function(color, options = {}) {
        globalColor = color || RANDOM_COLOR_LABEL;
        syncCompactColorInputs();
        const badge = document.getElementById("global-color-badge");
        if (badge) {
            const circle = badge.querySelector(".passport-card__badge-circle"),
                checkmark = badge.querySelector(".passport-card__badge-check"),
                hasColor = globalColor !== RANDOM_COLOR_LABEL;
            badge.classList.toggle("passport-card__badge--complete", hasColor);
            badge.classList.toggle("passport-card__badge--incomplete", !hasColor);
            circle && circle.classList.toggle("pc-hidden", hasColor);
            checkmark && checkmark.classList.toggle("pc-hidden", !hasColor);
        }
        options.skipProgress || updateProgress()
    };
    const croppers = Array(PASSPORT_COUNT).fill(null).map(() => ({
        current: null
    }));

    function showCropper(index) {
        const modal2 = document.getElementById(`passport-cropper-modal-${index}`);
        modal2 && (modal2.style.display = "flex", modal2.offsetHeight, modal2.classList.add("active"))
    }

    function resetPhotoUI(index) {
        const photo = passportData[index].photo;
        if (photo && photo.startsWith("blob:")) URL.revokeObjectURL(photo);
        passportData[index].photo = null;
        const visibleInput = document.getElementById(`passport-photo-${index}`);
        visibleInput && (visibleInput.value = "");
        const fileInput = document.querySelector(`[data-photo-input="${index}"]`);
        fileInput && (fileInput.value = "");
        const preview = document.querySelector(`[data-photo-preview="${index}"]`);
        preview && preview.classList.add("pc-hidden");
        const previewImg = document.querySelector(`[data-photo-img="${index}"]`);
        previewImg && (previewImg.src = "");
        const uploadArea = document.querySelector(`[data-photo-upload-area="${index}"]`);
        uploadArea && uploadArea.classList.remove("pc-hidden");
        const buttonText = document.querySelector(`[data-photo-button-text="${index}"]`);
        if (buttonText) {
            buttonText.textContent = TEXT_UPLOAD_PHOTO;
            const button = buttonText.closest(".passport-form__photo-button");
            button && button.classList.remove("passport-form__photo-button--secondary");
        }
    }

    function closeCropper(index, shouldClearImage = !1) {
        const modal2 = document.getElementById(`passport-cropper-modal-${index}`),
            cropperObj = croppers[index];
        if (modal2) {
            if (modal2.classList.remove("active"), shouldClearImage) {
                resetPhotoUI(index);
                updateProgress()
            }
            setTimeout(() => {
                modal2.style.display = "none", cropperObj && cropperObj.current && (cropperObj.current.destroy(), cropperObj.current = null)
            }, 300)
        }
    }

    function prepareCropper(index, file) {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (file.size > 15728640) {
            alert(TEXT_PHOTO_TOO_LARGE_ERROR);
            const input = document.querySelector(`[data-photo-input="${index}"]`);
            input && (input.value = "");
            return
        }
        if (!allowedTypes.includes(file.type)) {
            alert(TEXT_INVALID_IMAGE_FORMAT_ERROR);
            const input = document.querySelector(`[data-photo-input="${index}"]`);
            input && (input.value = "");
            return
        }
        const reader = new FileReader;
        reader.onload = function(e) {
            const cropperImage = document.getElementById(`passport-cropper-image-${index}`),
                cropperObj = croppers[index];
            cropperImage && (cropperImage.src = e.target.result, showCropper(index), loadExternalScript("cropper", "Cropper").then(() => {
                cropperObj && cropperObj.current && cropperObj.current.destroy(), cropperObj.current = new Cropper(cropperImage, {
                aspectRatio: 3 / 4,
                viewMode: 1,
                dragMode: "move",
                autoCropArea: 1,
                restore: !1,
                guides: !0,
                center: !0,
                highlight: !1,
                cropBoxMovable: !0,
                cropBoxResizable: !0,
                toggleDragModeOnDblclick: !1
            })
            }).catch(() => {
                alert(TEXT_INVALID_IMAGE_FORMAT_ERROR)
            }))
        }, reader.readAsDataURL(file)
    }

    function cropAndSaveImage(index) {
        const cropperObj = croppers[index];
        if (!cropperObj || !cropperObj.current) return;
        processingImages++;
        const cropBtn = document.getElementById(`passport-crop-button-${index}`);
        cropBtn && (cropBtn.disabled = !0, cropBtn.textContent = TEXT_CROP_PROCESSING), cropperObj.current.getCroppedCanvas({
            width: 375,
            height: 500
        }).toBlob(function(blob) {
            const croppedFile = new File([blob], "passport-photo.jpg", {
                    type: "image/jpeg"
                }),
                input = document.querySelector(`[data-photo-input="${index}"]`);
            if (input) {
                const dataTransfer = new DataTransfer;
                dataTransfer.items.add(croppedFile), input.files = dataTransfer.files
            }
            const preview = document.querySelector(`[data-photo-preview="${index}"]`),
                img = document.querySelector(`[data-photo-img="${index}"]`),
                uploadArea = document.querySelector(`[data-photo-upload-area="${index}"]`);
            passportData[index].photo && passportData[index].photo.startsWith("blob:") && URL.revokeObjectURL(passportData[index].photo);
            const blobUrl = URL.createObjectURL(blob);
            preview && img && (preview.classList.remove("pc-hidden"), img.src = blobUrl), uploadArea && uploadArea.classList.add("pc-hidden"), passportData[index].photo = blobUrl, processingImages--, cropBtn && (cropBtn.disabled = !1, cropBtn.textContent = TEXT_CROP_SAVE), closeCropper(index, !1), updateProgress(), window.trackPassportPersonalization("personalize_photo_upload")
        }, "image/jpeg", .9)
    }
    window.handlePhotoUpload = function(index, input) {
        const file = input.files?.[0];
        file && prepareCropper(index, file)
    }, window.removePhoto = function(index) {
        resetPhotoUI(index);
        updateProgress()
    };
    for (let i = 0; i < PASSPORT_COUNT; i++) {
        const closeBtn = document.querySelector(`.passport-cropper-close[data-cropper-index="${i}"]`),
            cancelBtn = document.getElementById(`passport-cancel-crop-${i}`),
            cropBtn = document.getElementById(`passport-crop-button-${i}`);
        closeBtn && closeBtn.addEventListener("click", () => closeCropper(i, !0)), cancelBtn && cancelBtn.addEventListener("click", () => closeCropper(i, !0)), cropBtn && cropBtn.addEventListener("click", () => cropAndSaveImage(i))
    }

    const MAX_SUBMITTED_PASSPORTS = 25;

    // Quantity being added to cart. Packs keep activeCount in sync with it,
    // but plain passport products let the shopper raise the quantity while the
    // customizer still renders a single card.
    function getCartQuantity(form) {
        let input = form && form.querySelector('input[name="quantity"]');
        if (!input && form && form.id) {
            input = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
        }
        const qty = parseInt(input && input.value, 10);
        return isNaN(qty) || qty < 1 ? 0 : qty;
    }

    // A passport the shopper never filled in must still reach fulfilment as a
    // blank passport instead of silently disappearing from the line item.
    function blankPassportTextProperties(i) {
        const num = i + 1;
        return [
            ["Pasaporte" + num, editionTags[i] || editionTags[0] || ""],
            ["Color" + num, (isCompactMode() ? globalColor : RANDOM_COLOR_LABEL) || RANDOM_COLOR_LABEL],
            ["Nombre" + num, ""],
            ["Apellidos" + num, ""],
            ["Nacionalidad" + num, ""],
            ["Frase" + num, ""]
        ];
    }

    function passportTextProperties(i) {
        const p = passportData[i],
            num = i + 1,
            props = [
                ["Pasaporte" + num, editionTags[i] || editionTags[0] || ""],
                ["Color" + num, (isCompactMode() ? globalColor : p.color) || RANDOM_COLOR_LABEL],
                ["Nombre" + num, window.stripPassportEmoji(p.firstName || "")],
                ["Apellidos" + num, window.stripPassportEmoji(p.lastName || "")],
                ["Nacionalidad" + num, window.stripPassportEmoji(p.nationality || "")]
            ];
        if ((isCaminoDeSantiago || isSnow) && p.fecha) props.push(["Fecha" + num, window.stripPassportEmoji(p.fecha)]);
        if (isSnow && p.modalidad) props.push(["Modalidad" + num, p.modalidad]);
        props.push(["Frase" + num, window.stripPassportEmoji(p.phrase || "")]);
        return props;
    }

    function isPassportComplete(passport) {
        const colorValid = (isCompactMode() ? globalColor : passport.color) || RANDOM_COLOR_LABEL,
            baseFieldsValid = passport.firstName && passport.lastName && passport.nationality && passport.photo;
        return isCaminoDeSantiago ? baseFieldsValid && passport.fecha && passport.phrase && colorValid : isSnow ? baseFieldsValid && passport.fecha && passport.modalidad && colorValid : baseFieldsValid && passport.phrase && colorValid
    }

    function updateProgress() {
        let completedCount = 0;
        passportData.forEach((passport, index) => {
            if (index >= activeCount) return;
            const isComplete = isPassportComplete(passport);
            isComplete && completedCount++;
            const card = document.querySelector(`.passport-card[data-passport-index="${index}"]`);
            if (!card) return;
            const badge = card.querySelector("[data-badge]"),
                badgeNumber = badge?.querySelector(".passport-card__badge-number"),
                badgeCheck = badge?.querySelector(".passport-card__badge-check"),
                subtitle = card.querySelector("[data-subtitle]"),
                completion = card.querySelector("[data-completion]");
            card.classList.toggle("passport-card--complete", isComplete);
            badge?.classList.toggle("passport-card__badge--complete", isComplete);
            badge?.classList.toggle("passport-card__badge--incomplete", !isComplete);
            badgeNumber?.classList.toggle("pc-hidden", isComplete);
            badgeCheck?.classList.toggle("pc-hidden", !isComplete);
            if (subtitle) subtitle.textContent = isComplete ? TEXT_ALL_COMPLETED : TEXT_CLICK_TO_COMPLETE;
            completion?.classList.toggle("passport-completion--show", isComplete);
        });
        const progressBar = document.getElementById("passport-progress-bar");
        if (progressBar) {
            const percentage = completedCount / activeCount * 100;
            progressBar.style.width = `${percentage}%`
        }
        const countEl = document.getElementById("passport-completed-count");
        countEl && completedCount !== previousCompletedCount && (countEl.classList.add("updating"), countEl.textContent = `${completedCount}/${activeCount}`, setTimeout(() => {
            countEl.classList.remove("updating")
        }, 300), previousCompletedCount = completedCount);
        const checkoutBtn = document.getElementById("passport-checkout-button"),
            checkoutBtnText = document.getElementById("passport-checkout-button-text");
        if (checkoutBtn && checkoutBtnText) {
            const isProcessing = processingImages > 0;
            checkoutBtn.disabled = isProcessing, isProcessing ? checkoutBtnText.textContent = TEXT_PROCESSING_IMAGES : checkoutBtnText.textContent = TEXT_ADD_TO_CART
        }
    }
    function resetAllPassportData() {
        for (let i = 0; i < PASSPORT_COUNT; i++) {
            const p = passportData[i];
            resetPhotoUI(i);
            Object.assign(p, { firstName: "", lastName: "", fecha: "", nationality: "", modalidad: "", phrase: "", color: RANDOM_COLOR_LABEL });
            ["passport-name-", "passport-surname-", "passport-nationality-", "passport-fecha-", "passport-modalidad-"].forEach(prefix => {
                const el = document.getElementById(prefix + i);
                el && (el.value = "");
            });
            const phraseInput = document.getElementById(`passport-phrase-${i}`);
            if (phraseInput) {
                phraseInput.value = "";
                const counter = document.getElementById(`passport-phrase-counter-${i}`);
                counter && (counter.textContent = "0");
                phraseInput.closest('.passport-form__textarea-wrap')?.classList.remove('has-value');
            }
            syncPassportColorInputs(i);
            const copy = document.getElementById("copy-from-" + i);
            copy && (copy.value = "");
        }
        globalColor = RANDOM_COLOR_LABEL;
        window.handleGlobalColorChange(globalColor, {
            skipProgress: !0
        });
        localStorage.removeItem("passportData");
        previousCompletedCount = -1;
        if (window.resetPackQty) {
            window.resetPackQty();
        } else if (window.setActivePassportCount) {
            window.setActivePassportCount(Math.max(baseCount, window.getPackCountFromSelection ? window.getPackCountFromSelection() : 1));
        }
        updateProgress();
    }
    function getPassportTitleText(index) {
        const titleEl = document.querySelector(`.passport-card[data-passport-index="${index}"] [data-title]`);
        const titleText = titleEl ? titleEl.textContent.replace(/\s+/g, " ").trim() : "";
        return titleText || `${TEXT_PASSPORT_LABEL} ${index + 1}`
    }
    window.resetAllPassportData = resetAllPassportData;
    window.goToNextPassport = function(currentIndex) {
        const nextIndex = currentIndex + 1;
        nextIndex < PASSPORT_COUNT && togglePassportCard(nextIndex, {
            scrollIntoView: !0,
            scrollBlock: "nearest"
        })
    }, window.openPassportPreview = function(index) {
        const passport = passportData[index],
            modal2 = document.getElementById("passport-preview-modal"),
            previewData = document.getElementById("passport-preview-data");
        previewData && (previewData.style.display = "block");
        const title = document.getElementById("passport-preview-title");
        if (title) {
            const fullName = `${passport.firstName} ${passport.lastName}`.trim();
            title.textContent = `${TEXT_PREVIEW_TITLE_PREFIX} - ${fullName || getPassportTitleText(index)}`
        }
        const editionTag = document.querySelector(`.passport-card[data-passport-index="${index}"]`)?.querySelector(".passport-title-edition")?.getAttribute("data-edition-tag") || "",
            editionKey = getEditionKey(editionTag),
            templateUrlsElement = document.getElementById("passport-template-urls"),
            templateUrl = (templateUrlsElement ? JSON.parse(templateUrlsElement.textContent) : {})[editionKey],
            templateImg = document.getElementById("passport-preview-template");
        templateImg && templateUrl && (templateImg.src = templateUrl);
        const previewName = document.getElementById("preview-name"),
            previewSurname = document.getElementById("preview-surname"),
            previewNationality = document.getElementById("preview-nationality"),
            previewPhrase = document.getElementById("preview-phrase"),
            previewFecha = document.getElementById("preview-fecha"),
            previewPhoto = document.getElementById("preview-photo");
        previewName && (previewName.textContent = passport.firstName || ""), previewSurname && (previewSurname.textContent = passport.lastName || ""), previewNationality && (previewNationality.textContent = passport.nationality || ""), previewPhrase && (previewPhrase.textContent = passport.phrase || ""), previewFecha && (passport.fecha ? (previewFecha.textContent = passport.fecha, previewFecha.style.display = "block") : (previewFecha.textContent = "", previewFecha.style.display = "none")), previewPhoto && passport.photo ? (previewPhoto.src = passport.photo, previewPhoto.style.display = "block") : previewPhoto && (previewPhoto.style.display = "none"), modal2.classList.add("passport-preview-modal--open"), document.body.style.overflow = "hidden", window.trackPassportPersonalization("personalize_preview_open")
    }, window.closePassportPreview = function() {
        document.getElementById("passport-preview-modal").classList.remove("passport-preview-modal--open"), document.body.style.overflow = ""
    }, window.downloadPassportPreview = function() {
        const wrapper = document.getElementById("passport-preview-wrapper"),
            saveBtn = document.getElementById("passport-preview-save-btn");
        if (!wrapper) return;
        const originalText = saveBtn.textContent;
        saveBtn.textContent = TEXT_PREVIEW_GENERATING, saveBtn.disabled = !0, saveBtn.blur(), requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                loadExternalScript("html2canvas", "html2canvas").then(() => html2canvas(wrapper, {
                    useCORS: !0,
                    allowTaint: !1,
                    scale: 2,
                    backgroundColor: null
                })).then(canvas => {
                    canvas.toBlob(blob => {
                        const url = URL.createObjectURL(blob),
                            link = document.createElement("a");
                        link.href = url, link.download = `${TEXT_PREVIEW_DOWNLOAD_FILENAME}.png`, document.body.appendChild(link), link.click(), document.body.removeChild(link), URL.revokeObjectURL(url), saveBtn.textContent = originalText, saveBtn.disabled = !1, window.trackPassportPersonalization("personalize_complete")
                    }, "image/png")
                }).catch(() => {
                    alert(TEXT_PREVIEW_GENERATE_ERROR), saveBtn.textContent = originalText, saveBtn.disabled = !1
                })
            })
        })
    };

    function getWeglotCartUrl() {
        const firstPart = window.location.pathname.split("/")[1];
        return firstPart && firstPart.length === 2 ? `/${firstPart}/cart` : "/cart"
    }
    window.getWeglotCartUrl = getWeglotCartUrl;
    async function blobUrlToBase64(blobUrl) {
        try {
            const blob = await (await fetch(blobUrl)).blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader;
                reader.onloadend = () => resolve(reader.result), reader.onerror = reject, reader.readAsDataURL(blob)
            })
        } catch (error) {
            return null
        }
    }
    async function persistPassportData() {
        const dataToSave = await Promise.all(passportData.map(async passport => {
            const passportCopy = { ...passport };
            if (passportCopy.photo && passportCopy.photo.startsWith("blob:")) {
                passportCopy.photo = await blobUrlToBase64(passportCopy.photo);
            }
            return passportCopy;
        }));
        localStorage.setItem("passportData", JSON.stringify({
            passports: dataToSave,
            globalColor
        }));
    }
    window.saveForLater = async function() {
        try {
            await persistPassportData();
            alert(TEXT_SAVE_FOR_LATER_SUCCESS)
        } catch (e) {
            e.name === "QuotaExceededError" ? (alert(TEXT_SAVE_FOR_LATER_QUOTA_ERROR)) : (alert(TEXT_SAVE_FOR_LATER_ERROR))
        }
    }, window.continueToCheckout = function() {
        if (isSubmitting) return;
        if (processingImages > 0) {
            alert(TEXT_WAIT_FOR_IMAGES);
            return
        }
        isSubmitting = !0;
        const checkoutBtn = document.getElementById("passport-checkout-button"),
            checkoutBtnText = document.getElementById("passport-checkout-button-text");
        checkoutBtn && (checkoutBtn.disabled = !0), checkoutBtnText && (checkoutBtnText.textContent = TEXT_CHECKOUT_PROCESSING);
        const productFormId = document.getElementById("passport-customizer-modal")?.getAttribute("data-product-form-id");
        if (!productFormId) {
            alert(TEXT_PRODUCT_FORM_NOT_FOUND_ERROR), isSubmitting = !1, checkoutBtn && (checkoutBtn.disabled = !1), checkoutBtnText && (checkoutBtnText.textContent = TEXT_CONTINUE_TO_CHECKOUT);
            return
        }
        const variantIdInput = document.querySelector(`#${productFormId} input[name="id"]`),
            variantId = variantIdInput ? variantIdInput.value : null;
        if (!variantId) {
            alert(TEXT_PRODUCT_VARIANT_NOT_FOUND_ERROR), isSubmitting = !1, checkoutBtn && (checkoutBtn.disabled = !1), checkoutBtnText && (checkoutBtnText.textContent = TEXT_CONTINUE_TO_CHECKOUT);
            return
        }
        const formData = new FormData;
        formData.append("id", variantId), formData.append("quantity", 1);
        const cartDrawerForSections = document.querySelector("cart-drawer");
        cartDrawerForSections && typeof cartDrawerForSections.getSectionsToRender == "function" && (formData.append("sections", cartDrawerForSections.getSectionsToRender().map(s => s.id).join(",")), formData.append("sections_url", window.location.pathname));
        async function blobUrlToFile(blobUrl, fileName) {
            const blob = await (await fetch(blobUrl)).blob();
            return new File([blob], fileName, {
                type: "image/jpeg"
            })
        }
        async function addPassportProperties() {
            for (let i = 0; i < activeCount; i++) {
                const passport = passportData[i],
                    passportNumber = i + 1;
                for (const [name, value] of passportTextProperties(i)) {
                    formData.append(`properties[${name}]`, value);
                }
                if (passport.photo) try {
                    const photoFile = await blobUrlToFile(passport.photo, `passport-${passportNumber}.jpg`);
                    formData.append(`properties[Imagen${passportNumber}]`, photoFile)
                } catch (error) {}
            }
        }
        addPassportProperties().then(() => {
            fetch("/cart/add.js", {
                method: "POST",
                body: formData
            }).then(response => response.json()).then(data => {
                const cartDrawer = document.querySelector("cart-drawer");
                cartDrawer && typeof cartDrawer.renderContents == "function" && data.sections ? (window.closePassportCustomizer(), cartDrawer.renderContents(data), cartDrawer.classList.contains("is-empty") && cartDrawer.classList.remove("is-empty"), isSubmitting = !1, checkoutBtn && (checkoutBtn.disabled = !1), checkoutBtnText && (checkoutBtnText.textContent = TEXT_ADD_TO_CART)) : window.location.href = getWeglotCartUrl()
            }).catch(error => {
                alert(TEXT_ADD_TO_CART_ERROR), isSubmitting = !1, checkoutBtn && (checkoutBtn.disabled = !1), checkoutBtnText && (checkoutBtnText.textContent = TEXT_ADD_TO_CART)
            })
        }).catch(error => {
            alert(TEXT_PREPARE_DATA_ERROR), isSubmitting = !1, checkoutBtn && (checkoutBtn.disabled = !1), checkoutBtnText && (checkoutBtnText.textContent = TEXT_ADD_TO_CART)
        })
    };
    const savedData = localStorage.getItem("passportData");
    if (savedData) try {
        const parsedSavedData = JSON.parse(savedData),
            savedPassports = Array.isArray(parsedSavedData) ? parsedSavedData : parsedSavedData.passports || [];
        !Array.isArray(parsedSavedData) && parsedSavedData.globalColor && (globalColor = parsedSavedData.globalColor), savedPassports.forEach((data, index) => {
            if (index < PASSPORT_COUNT) {
                ["firstName", "lastName", "nationality", "fecha", "phrase"].forEach(key => {
                    data[key] && (data[key] = window.stripPassportEmoji(data[key]))
                });
                if (Object.assign(passportData[index], data), data.firstName) {
                    const firstNameInput = document.getElementById(`passport-name-${index}`);
                    firstNameInput && (firstNameInput.value = data.firstName)
                }
                if (data.lastName) {
                    const lastNameInput = document.getElementById(`passport-surname-${index}`);
                    lastNameInput && (lastNameInput.value = data.lastName)
                }
                if (data.nationality) {
                    const nationalityInput = document.getElementById(`passport-nationality-${index}`);
                    nationalityInput && (nationalityInput.value = data.nationality)
                }
                if (data.fecha) {
                    const fechaInput = document.getElementById(`passport-fecha-${index}`);
                    fechaInput && (fechaInput.value = data.fecha)
                }
                if (data.modalidad) {
                    const modalidadInput = document.getElementById(`passport-modalidad-${index}`);
                    modalidadInput && (modalidadInput.value = data.modalidad)
                }
                if (data.phrase) {
                    const phraseInput = document.getElementById(`passport-phrase-${index}`);
                    if (phraseInput) {
                        phraseInput.value = data.phrase;
                        const counter = document.getElementById(`passport-phrase-counter-${index}`);
                        counter && (counter.textContent = data.phrase.length);
                        phraseInput.closest('.passport-form__textarea-wrap')?.classList.add('has-value')
                    }
                }
                syncPassportColorInputs(index);
                if (data.photo) {
                    const uploadArea = document.querySelector(`[data-photo-upload-area="${index}"]`);
                    uploadArea && uploadArea.classList.add("pc-hidden");
                    const preview = document.querySelector(`[data-photo-preview="${index}"]`),
                        img = document.querySelector(`[data-photo-img="${index}"]`);
                    preview && img && (preview.classList.remove("pc-hidden"), img.src = data.photo)
                }
            }
        }), window.handleGlobalColorChange(globalColor, {
            skipProgress: !0
        }), updateProgress()
    } catch (e) {
        }
    window.copyPassportData = function(fromIndexStr, toIndex) {
        const fromIndex = parseInt(fromIndexStr);
        if (fromIndexStr === "" || isNaN(fromIndex)) return;
        Object.assign(passportData[toIndex], { ...passportData[fromIndex] });
        const firstNameInput = document.getElementById(`passport-name-${toIndex}`);
        firstNameInput && (firstNameInput.value = passportData[toIndex].firstName);
        const lastNameInput = document.getElementById(`passport-surname-${toIndex}`);
        lastNameInput && (lastNameInput.value = passportData[toIndex].lastName);
        const nationalityInput = document.getElementById(`passport-nationality-${toIndex}`);
        nationalityInput && (nationalityInput.value = passportData[toIndex].nationality);
        const fechaInput = document.getElementById(`passport-fecha-${toIndex}`);
        fechaInput && (fechaInput.value = passportData[toIndex].fecha);
        const modalidadInput = document.getElementById(`passport-modalidad-${toIndex}`);
        modalidadInput && (modalidadInput.value = passportData[toIndex].modalidad);
        const phraseInput = document.getElementById(`passport-phrase-${toIndex}`);
        if (phraseInput) {
            phraseInput.value = passportData[toIndex].phrase;
            const counter = document.getElementById(`passport-phrase-counter-${toIndex}`);
            counter && (counter.textContent = passportData[toIndex].phrase.length);
            phraseInput.closest('.passport-form__textarea-wrap')?.classList.toggle('has-value', !!passportData[toIndex].phrase)
        }
        syncPassportColorInputs(toIndex);
        const hasPhoto = !!passportData[toIndex].photo;
        const uploadArea = document.querySelector(`[data-photo-upload-area="${toIndex}"]`);
        const buttonText = document.querySelector(`[data-photo-button-text="${toIndex}"]`);
        const preview = document.querySelector(`[data-photo-preview="${toIndex}"]`);
        const img = document.querySelector(`[data-photo-img="${toIndex}"]`);
        uploadArea && uploadArea.classList.toggle("pc-hidden", hasPhoto);
        if (buttonText) {
            buttonText.textContent = hasPhoto ? TEXT_CHANGE_PHOTO : TEXT_UPLOAD_PHOTO;
            const button = buttonText.closest(".passport-form__photo-button");
            button && button.classList.toggle("passport-form__photo-button--secondary", hasPhoto)
        }
        preview && preview.classList.toggle("pc-hidden", !hasPhoto);
        img && (img.src = hasPhoto ? passportData[toIndex].photo : "");
        const srcPhotoInput = document.querySelector(`[data-photo-input="${fromIndex}"]`);
        const destPhotoInput = document.querySelector(`[data-photo-input="${toIndex}"]`);
        if (destPhotoInput && srcPhotoInput && srcPhotoInput.files && srcPhotoInput.files.length) {
            try {
                const dt = new DataTransfer();
                dt.items.add(srcPhotoInput.files[0]);
                destPhotoInput.files = dt.files;
            } catch (e) {}
        } else if (destPhotoInput && passportData[toIndex].photo) {
            (async () => {
                try {
                    const blob = await (await fetch(passportData[toIndex].photo)).blob();
                    const file = new File([blob], `passport-${toIndex + 1}.jpg`, { type: "image/jpeg" });
                    const dt = new DataTransfer();
                    dt.items.add(file);
                    destPhotoInput.files = dt.files;
                } catch (e) {}
            })();
        }
        updateProgress()
    }, window.openPassportExampleModal = function(index) {
        const modal2 = document.getElementById("passport-preview-modal"),
            templateImg = document.getElementById("passport-preview-template"),
            previewData = document.getElementById("passport-preview-data"),
            title = document.getElementById("passport-preview-title");
        if (!modal2 || !templateImg || !previewData) return;
        const editionTag = document.querySelector(`.passport-card[data-passport-index="${index}"]`)?.querySelector(".passport-title-edition")?.getAttribute("data-edition-tag") || "",
            editionKey = getEditionKey(editionTag),
            exampleUrlsElement = document.getElementById("passport-example-urls"),
            exampleUrls = exampleUrlsElement ? JSON.parse(exampleUrlsElement.textContent) : {},
            exampleUrl = exampleUrls[editionKey] || exampleUrls.world;
        title && (title.textContent = TEXT_EXAMPLE_TITLE), templateImg.src = exampleUrl, previewData && (previewData.style.display = "none"), modal2.classList.add("passport-preview-modal--open"), document.body.style.overflow = "hidden"
    }, window.getPassportData = function() {
        return passportData
    }, window.isPassportComplete = isPassportComplete, window.openPassportCard = function(index, options = {}) {
        window.togglePassportCard(index, options)
    }, window.getPassportConfig = function() {
        return {
            PASSPORT_COUNT,
            activeCount,
            editionTags,
            isCompact: isCompactMode(),
            globalColor,
            randomColorLabel: RANDOM_COLOR_LABEL,
            familiaDefault
        }
    }, window.blobUrlToBase64 = blobUrlToBase64;

    const familiaDefault = parseInt(modal.getAttribute("data-familia-default")) || 3;

    function mapPackCount(text) {
        if (!text) return 1;
        const t = text.toLowerCase();
        if (/familia|family|tr[ií]o|3\s*pasaporte|3\s*passport/.test(t)) return 3;
        if (/cuarteto|cu[aá]druple|4\s*pasaporte|4\s*passport/.test(t)) return 4;
        if (/pareja|couple|d[uú]o|2\s*pasaporte|2\s*passport/.test(t)) return 2;
        return 1;
    }

    const VARIANT_SELECTORS =
        'variant-selects, variant-radios, .product-form__input, fieldset.product-form__input';

    function isCustomizerEl(el) {
        return el.closest && (el.closest("#passport-customizer-modal") || el.closest(".ppc"));
    }

    function belongsToProductForm(el) {
        if (!el || !PRODUCT_FORM_ID) return true;
        if (el.getAttribute && el.getAttribute("form") === PRODUCT_FORM_ID) return true;
        if (el.form && el.form.id === PRODUCT_FORM_ID) return true;
        var productForm = document.getElementById(PRODUCT_FORM_ID);
        return !!(productForm && productForm.contains(el));
    }

    function countFromSelection() {
        let n = 1;
        document.querySelectorAll(
            'variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked, .product-form__input input[type="radio"]:checked'
        ).forEach(function(r) {
            if (isCustomizerEl(r) || !belongsToProductForm(r)) return;
            var directCount = parseInt(r.dataset.packCount || "", 10);
            if (!isNaN(directCount) && directCount > 0) {
                n = Math.max(n, directCount);
                return;
            }
            let txt = r.value || "";
            const lab = r.id ? document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(r.id) : r.id) + '"]') : null;
            if (lab) txt += " " + lab.textContent;
            n = Math.max(n, mapPackCount(txt));
        });
        document.querySelectorAll(
            'variant-selects select, variant-radios select, .product-form__input select, select[name^="options"]'
        ).forEach(function(s) {
            if (isCustomizerEl(s) || s.name === "id" || !belongsToProductForm(s)) return;
            const opt = s.options[s.selectedIndex];
            var directCount = opt ? parseInt(opt.dataset.packCount || "", 10) : NaN;
            if (!isNaN(directCount) && directCount > 0) {
                n = Math.max(n, directCount);
                return;
            }
            n = Math.max(n, mapPackCount(opt ? opt.textContent + " " + opt.value : s.value));
        });
        return n;
    }

    function setActiveCount(n) {
        n = Math.max(1, Math.min(PASSPORT_COUNT, n));
        activeCount = n;
        for (let i = 0; i < PASSPORT_COUNT; i++) {
            const card = document.querySelector(`.passport-card[data-passport-index="${i}"]`);
            if (card) card.classList.toggle("passport-card--hidden", i >= n);
            const copy = document.getElementById("copy-from-" + i);
            if (copy) {
                const field = copy.closest(".passport-form__field");
                if (field) field.style.display = n > 1 ? "" : "none";
                Array.prototype.forEach.call(copy.options, function(o) {
                    if (o.value !== "") o.hidden = parseInt(o.value) >= n;
                });
                if (copy.options[copy.selectedIndex] && copy.options[copy.selectedIndex].hidden) copy.value = "";
            }
        }
        const openVisible = document.querySelector(".passport-card:not(.passport-card--hidden) .passport-card__content--expanded");
        if (!openVisible) window.togglePassportCard && window.togglePassportCard(0);
        previousCompletedCount = -1;
        updateProgress();
    }
    window.setActivePassportCount = setActiveCount;
    window.getActivePassportCount = function() { return activeCount; };
    window.getPackCountFromSelection = countFromSelection;

    function ppcAddInput(form, type, name, value) {
        const inp = document.createElement("input");
        inp.type = type;
        inp.name = name;
        inp.className = "ppc-prop";
        inp.style.display = "none";
        if (type !== "file") inp.value = value;
        form.appendChild(inp);
        return inp;
    }
    window.syncPassportProperties = function() {
        const form = (PRODUCT_FORM_ID && document.getElementById(PRODUCT_FORM_ID)) ||
            document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
            document.querySelector("product-form form");
        if (!form) return;
        form.querySelectorAll(".ppc-prop").forEach(function(el) {
            el.remove();
        });
        const submitCount = Math.min(
            Math.max(activeCount, getCartQuantity(form)),
            MAX_SUBMITTED_PASSPORTS
        );
        for (let i = 0; i < submitCount; i++) {
            const num = i + 1;
            const isTracked = i < activeCount && passportData[i];
            const props = isTracked ? passportTextProperties(i) : blankPassportTextProperties(i);
            for (const [name, value] of props) {
                ppcAddInput(form, "hidden", `properties[${name}]`, value);
            }
            if (!isTracked) continue;
            const src = document.querySelector(`[data-photo-input="${i}"]`);
            if (src && src.files && src.files.length) {
                const fi = ppcAddInput(form, "file", `properties[Imagen${num}]`, "");
                try {
                    const dt = new DataTransfer();
                    dt.items.add(src.files[0]);
                    fi.files = dt.files;
                } catch (e) {
                    try {
                        fi.files = src.files;
                    } catch (e2) {}
                }
            }
        }
    };

    var hasPackQty = !!document.querySelector('[data-pack-qty]');
    var baseCount = activeCount;
    if (!hasPackQty) {
        document.addEventListener("change", function(e) {
            const t = e.target;
            if (!t || isCustomizerEl(t)) return;
            if (t.name === 'quantity' || (t.closest && t.closest('[id^="Quantity-Form"]'))) return;
            if ((t.closest && t.closest(VARIANT_SELECTORS)) || t.name === "id") {
                setActiveCount(Math.max(baseCount, countFromSelection()));
            }
        }, false);
    }

    setActiveCount(Math.max(baseCount, countFromSelection()));
})(), (function() {
    "use strict";
    function shouldSkipSync(form) {
        if (!form) return false;
        if (window.shouldSkipPassportSyncForForm && window.shouldSkipPassportSyncForForm(form)) {
            return true
        }
        if (window.shouldPromptPassportPersonalizationForForm && window.shouldPromptPassportPersonalizationForForm(form)) {
            return true
        }
        return false
    }
    function syncNow() {
        if (window.syncPassportProperties) window.syncPassportProperties();
    }
    document.addEventListener("submit", function(e) {
        var form = e.target;
        if (form && form.tagName === "FORM" && form.closest("product-form") && !shouldSkipSync(form)) syncNow();
    }, true);
    document.addEventListener("click", function(e) {
        var btn = e.target.closest && e.target.closest('button[type="submit"], button[name="add"], input[type="submit"]');
        var form = btn && (btn.form || btn.closest("form"));
        if (btn && btn.closest("product-form") && !shouldSkipSync(form)) syncNow();
    }, true);
    var nativeFetch = window.fetch;
    window.fetch = function() {
        var url = arguments[0];
        var isCartAdd = typeof url === "string" && url.indexOf("/cart/add") !== -1;
        var isPersonalizedAdd = isCartAdd && window.isPersonalizedPassportCartAdd(arguments[1] && arguments[1].body);
        var result = nativeFetch.apply(this, arguments);
        if (isCartAdd) {
            result.then(function(response) {
                if (!response || !response.ok) return;
                if (isPersonalizedAdd) window.trackPassportPersonalization("add_to_cart_personalizar");
                if (window.resetAllPassportData)
                    setTimeout(function() { window.resetAllPassportData(); }, 0);
            }).catch(function() {});
        }
        return result;
    };
})(), (function() {
    "use strict";
    // Delegated + capture phase so it runs BEFORE the customizer's own input
    // listener (passportData, phrase counter) and also covers cart-drawer edit
    // fields that are re-rendered after load.
    const FIELD_SELECTOR = "#passport-customizer-modal input[data-field]:not([type=radio]):not([type=file]), #passport-customizer-modal textarea[data-field], .cart-pef__input, .no-emoji-input";
    const strip = window.stripPassportEmoji;

    function getErrorText() {
        const modal = document.getElementById("passport-customizer-modal");
        return (modal && modal.getAttribute("data-text-emoji-not-allowed")) || "No se permiten emojis";
    }

    function showError(el) {
        let msg = el._emojiErrorMsg;
        if (!msg || !msg.isConnected) {
            msg = document.createElement("span");
            msg.className = "emoji-error-message";
            msg.style.cssText = "display:block;color:#d32f2f;font-size:1.2rem;margin-top:4px;";
            el.insertAdjacentElement("afterend", msg);
            el._emojiErrorMsg = msg;
        }
        msg.textContent = getErrorText();
        msg.style.display = "block";
        el.style.borderColor = "#d32f2f";
        clearTimeout(el._emojiErrorTimer);
        el._emojiErrorTimer = setTimeout(() => {
            msg.style.display = "none";
            el.style.borderColor = "";
        }, 3e3);
    }

    function cleanField(el) {
        const value = el.value;
        const cleaned = strip(value);
        if (cleaned === value) return;
        let caret = null;
        try { caret = el.selectionStart; } catch (err) {}
        el.value = cleaned;
        if (caret !== null) {
            const newCaret = Math.max(0, caret - (value.length - cleaned.length));
            try { el.setSelectionRange(newCaret, newCaret); } catch (err) {}
        }
        showError(el);
    }

    document.addEventListener("input", function(e) {
        const el = e.target;
        if (!el || !el.matches || !el.matches(FIELD_SELECTOR) || e.isComposing) return;
        cleanField(el);
    }, true);

    document.addEventListener("compositionend", function(e) {
        const el = e.target;
        if (!el || !el.matches || !el.matches(FIELD_SELECTOR)) return;
        const before = el.value;
        cleanField(el);
        if (el.value !== before) el.dispatchEvent(new Event("input", { bubbles: true }));
    }, true);
})();

(function() {
    "use strict";
    var wrap = document.querySelector('[data-pack-qty]');
    if (!wrap) return;
    var inp = wrap.querySelector('input[name="quantity"]');
    if (!inp) return;
    var qtyComp = wrap.querySelector("quantity-input");
    var productFormId = inp.getAttribute("form") || (inp.form && inp.form.id) || "";

    function belongsToProductForm(el) {
        if (!el || !productFormId) return true;
        if (el.getAttribute && el.getAttribute("form") === productFormId) return true;
        if (el.form && el.form.id === productFormId) return true;
        var productForm = document.getElementById(productFormId);
        return !!(productForm && productForm.contains(el));
    }

    function packMin() {
        return window.getPackCountFromSelection ? window.getPackCountFromSelection() : 1;
    }

    function familyDefaultQty() {
        return (window.getPassportConfig && window.getPassportConfig().familiaDefault) || 3;
    }

    function isCompactFormatValue(value) {
        return window.isPassportCompactText(value);
    }

    var baseMin = parseInt(inp.dataset.baseMin, 10) || parseInt(inp.getAttribute("min"), 10) || parseInt(inp.dataset.min, 10) || 1;
    var lastPackCount = packMin();
    var desiredQty = parseInt(inp.value, 10) || 1;

    // FAMILIA 4+ ---------------------------------------------------------
    // Prices are per passport and FAMILIA covers 3 or more, so a hidden
    // "FAMILIA 4+" variant carries the Family price. Shoppers never pick it:
    // when the counter reaches 4 the form's variant id moves to the 4+ variant
    // with the same format, and back to FAMILIA below 4. Map comes from
    // sections/main-product.liquid ([data-familia-plus-map]).
    var FP_MIN = 4;
    var fpMap = {};
    var fpReverse = {};
    try {
        var fpEl = document.querySelector("[data-familia-plus-map]");
        if (fpEl) fpMap = JSON.parse(fpEl.textContent) || {};
    } catch (e) {
        fpMap = {};
    }
    Object.keys(fpMap).forEach(function(baseId) {
        fpReverse[String(fpMap[baseId])] = baseId;
    });
    var fpEnabled = Object.keys(fpMap).length > 0;
    var fpRefreshPrice = true;
    var fpPriceToken = 0;

    function fpIdInput() {
        var form = productFormId && document.getElementById(productFormId);
        return form ? form.querySelector('input[name="id"]') : null;
    }

    function fpRenderPrice(variantId) {
        var info = wrap.closest("product-info") || document.querySelector("product-info");
        var sectionId = info && info.dataset.section;
        if (!sectionId) return;
        var baseUrl = (info.dataset.url || window.location.pathname).split("?")[0];
        var token = ++fpPriceToken;
        fetch(baseUrl + "?variant=" + encodeURIComponent(variantId) + "&section_id=" + encodeURIComponent(sectionId))
            .then(function(response) { return response.text(); })
            .then(function(html) {
                var idInput = fpIdInput();
                // A newer switch or a Dawn variant change won the race: keep its price.
                if (token !== fpPriceToken || !idInput || String(idInput.value) !== String(variantId)) return;
                var fresh = new DOMParser().parseFromString(html, "text/html").getElementById("price-" + sectionId);
                var current = document.getElementById("price-" + sectionId);
                if (fresh && current) current.innerHTML = fresh.innerHTML;
            })
            .catch(function() {});
    }

    function fpSync(passportCount) {
        if (!fpEnabled) return;
        var idInput = fpIdInput();
        if (!idInput) return;
        var current = String(idInput.value);
        var target = current;
        if (passportCount >= FP_MIN && fpMap[current]) target = String(fpMap[current]);
        else if (passportCount < FP_MIN && fpReverse[current]) target = fpReverse[current];
        if (target === current) return;
        // Plain value change on purpose: a "change" event would run onVariantChange
        // and reset the counter to 3.
        idInput.value = target;
        if (fpRefreshPrice) fpRenderPrice(target);
    }

    function getPreferredPackFormatRadio(fieldset) {
        var radios = Array.from(fieldset.querySelectorAll('input[type="radio"]:not(.disabled):not([disabled])'));
        if (!radios.length) return null;
        var checkedNonCompact = radios.find(function(radio) {
            return radio.checked && !isCompactFormatValue(radio.value);
        });
        if (checkedNonCompact) return checkedNonCompact;
        return radios.find(function(radio) {
            return !isCompactFormatValue(radio.value);
        }) || radios[0];
    }

    function getPreferredPackFormatOption(select) {
        var options = Array.from(select.options || []).filter(function(option) {
            return !option.disabled;
        });
        if (!options.length) return null;
        var selectedNonCompact = options.find(function(option) {
            return option.selected && !isCompactFormatValue(option.value || option.textContent);
        });
        if (selectedNonCompact) return selectedNonCompact;
        return options.find(function(option) {
            return !isCompactFormatValue(option.value || option.textContent);
        }) || options[0];
    }

    function syncPackFormatFieldsets(packCount) {
        var selectionChanged = false;
        document.querySelectorAll('[data-pack-format-fieldset]').forEach(function(fieldset) {
            var optionCount = parseInt(fieldset.getAttribute('data-pack-format-option-count') || '0', 10);
            var shouldShow = optionCount > 1 && packCount > 1;
            fieldset.style.display = shouldShow ? '' : 'none';

            if (shouldShow || selectionChanged) return;

            var preferredRadio = getPreferredPackFormatRadio(fieldset);
            if (preferredRadio && !preferredRadio.checked) {
                preferredRadio.checked = true;
                preferredRadio.dispatchEvent(new Event('change', { bubbles: true }));
                selectionChanged = true;
                return;
            }

            var formatSelect = fieldset.querySelector('select');
            var preferredOption = formatSelect ? getPreferredPackFormatOption(formatSelect) : null;
            if (formatSelect && preferredOption && formatSelect.value !== preferredOption.value) {
                formatSelect.value = preferredOption.value;
                preferredOption.selected = true;
                formatSelect.dispatchEvent(new Event('change', { bubbles: true }));
                selectionChanged = true;
            }
        });
        return selectionChanged;
    }

    function applyQty() {
        var packCount = packMin();
        var showQuantitySelector = packCount >= 3;
        var lockedQty = packCount > 1 ? packCount : baseMin;
        wrap.style.display = showQuantitySelector ? "" : "none";
        if (desiredQty < baseMin) desiredQty = baseMin;
        if (showQuantitySelector && desiredQty < packCount) desiredQty = packCount;
        inp.min = inp.dataset.min = showQuantitySelector ? packCount : lockedQty;
        inp.value = showQuantitySelector ? desiredQty : lockedQty;
        if (qtyComp && qtyComp.validateQtyRules) qtyComp.validateQtyRules();
        var qty = parseInt(inp.value, 10) || 1;
        var effectiveCount = showQuantitySelector ? qty : (packCount > 1 ? packCount : 1);
        if (window.setActivePassportCount) window.setActivePassportCount(effectiveCount);
        fpSync(showQuantitySelector ? qty : 1);
        if (syncPackFormatFieldsets(packCount)) return;
        var packIndex = 1;
        document.querySelectorAll('.product-form__card-group--1 input[type="radio"]').forEach(function(r, i) {
            if (r.checked) packIndex = i + 1;
        });
        document.querySelectorAll('.product-form__card-group--2 .product-form__card-desc').forEach(function(span) {
            var desc = span.getAttribute('data-desc-' + packIndex);
            if (desc) span.textContent = desc;
        });
        checkCompactDisable(effectiveCount);
    }

    function onVariantChange() {
        var packCount = packMin();
        var previousPackCount = lastPackCount;
        lastPackCount = packCount;
        if (packCount >= 3) {
            desiredQty = packCount;
        } else if (packCount == 2) {
            desiredQty = 2;
        } else if (previousPackCount > 1) {
            desiredQty = baseMin;
        } else if (desiredQty < baseMin) {
            desiredQty = baseMin;
        }
        // Dawn is already rendering the newly selected variant (price included);
        // do not fetch a price that would race with it.
        fpRefreshPrice = false;
        applyQty();
        fpRefreshPrice = true;
    }

    function getSelectedFormat() {
        var checkedRadios = document.querySelectorAll('[data-pack-format-fieldset] input[type="radio"]:checked');
        for (var i = 0; i < checkedRadios.length; i++) {
            if (belongsToProductForm(checkedRadios[i])) return (checkedRadios[i].value || '').toLowerCase();
        }
        var formatSelects = document.querySelectorAll('[data-pack-format-fieldset] select');
        for (var j = 0; j < formatSelects.length; j++) {
            var formatSelect = formatSelects[j];
            if (!belongsToProductForm(formatSelect)) continue;
            return ((formatSelect.value || formatSelect.options[formatSelect.selectedIndex]?.textContent) || '').toLowerCase();
        }
        return '';
    }

    function checkCompactDisable(effectivePassportCount) {
        var qty = effectivePassportCount || parseInt(inp.value, 10) || 1;
        document.querySelectorAll('.product-form__card-group--2 input[type="radio"]').forEach(function(radio) {
            var val = (radio.value || '').toLowerCase();
            if (isCompactFormatValue(val)) {
                if (qty > 4) {
                    radio.classList.add('disabled');
                    radio.disabled = true;
                    if (radio.checked) {
                        var other = radio.closest('.product-form__card-group--2').querySelector('input[type="radio"]:not(.disabled)');
                        if (other) {
                            other.checked = true;
                            other.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                } else {
                    radio.classList.remove('disabled');
                    radio.disabled = false;
                }
            }
        });
        toggleLinternaFields();
    }

    function toggleLinternaFields() {
        var isCompact = window.getPassportConfig ? !!window.getPassportConfig().isCompact : isCompactFormatValue(getSelectedFormat());
        document.querySelectorAll('[data-compact-color-field]').forEach(function(field) {
            field.classList.toggle('pc-hidden', !isCompact);
            field.style.display = isCompact ? '' : 'none';
        });
        document.querySelectorAll('[data-passport-color-field]').forEach(function(field) {
            field.style.display = isCompact ? 'none' : '';
        });
    }

    function onUserQtyChange() {
        var packCount = packMin();
        if (packCount == 2) {
            desiredQty = 2;
            applyQty();
            return;
        }
        if (packCount >= 3) {
            var familyQty = parseInt(inp.value, 10) || packCount;
            desiredQty = familyQty < packCount ? packCount : familyQty;
            applyQty();
            return;
        }
        var v = parseInt(inp.value, 10) || baseMin;
        desiredQty = v < baseMin ? baseMin : v;
        applyQty();
    }

    document.addEventListener("change", function(e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest(".ppc") || t.closest("#passport-customizer-modal") || t.closest("[data-pack-qty]")) return;
        if (!belongsToProductForm(t)) return;
        if (t.closest('variant-selects, variant-radios, .product-form__input, fieldset.product-form__input') || t.name === "id") {
            setTimeout(onVariantChange, 0);
        }
    }, false);

    inp.addEventListener("change", onUserQtyChange);
    inp.addEventListener("input", onUserQtyChange);

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, function() {
            var packCount = packMin();
            if (packCount == 2) {
                desiredQty = 2;
                if (parseInt(inp.value, 10) !== 2) applyQty();
                return;
            }
            if (packCount >= 3) {
                var familyQty = parseInt(inp.value, 10) || packCount;
                desiredQty = familyQty < packCount ? packCount : familyQty;
                applyQty();
                return;
            }
            if (desiredQty < baseMin) desiredQty = baseMin;
            if (parseInt(inp.value, 10) !== desiredQty) applyQty();
        });
    }

    window.resetPackQty = function() {
        var packCount = packMin();
        if (packCount >= 3) {
            desiredQty = packCount;
        } else if (packCount == 2) {
            desiredQty = 2;
        } else {
            desiredQty = baseMin;
        }
        applyQty();
    };

    window.toggleLinternaFields = toggleLinternaFields;

    // Landing on a FAMILIA 4+ variant (shared link, feed): keep 4 passports.
    var fpInitialInput = fpIdInput();
    var fpInitialIsPlus = !!(fpEnabled && fpInitialInput && fpReverse[String(fpInitialInput.value)]);
    var fpInitialQty = parseInt(inp.value, 10) || FP_MIN;
    onVariantChange();
    if (fpInitialIsPlus) {
        desiredQty = Math.max(FP_MIN, fpInitialQty);
        applyQty();
    }
})();
